import React, {Component} from 'react';
import T from "i18n-react";
// Style
import './DynamicTable.css';
//Components
import Pagination from "../../pagination/Pagination";
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn,} from 'material-ui/Table';
//Services

const ROW_BY_PAGE_OPTIONS = [10, 20, 50];

//Template de tableau paginé qui s'adapte à la hauteur qui est disponible
class DynamicTable extends Component {

    render() {
        return (
            <div className="dynamicTable">
                <Table
                    //Certaines options sont activées par défaut par material UI --> on les set toutes a false par défaut
                    fixedHeader={this.props.fixedHeader || false}
                    fixedFooter={this.props.fixedFooter || false}
                    selectable={this.props.selectable || false}
                    multiSelectable={this.props.multiSelectable || false}
                    onRowSelection={this.handleSelection.bind(this)}
                >
                    {this.displayHeaders(this.props.headerList)}
                    {this.displayBody()}
                </Table>
                <div className="pagination">
                    <Pagination total={parseInt(this.props.totalRowNumber, 10)}
                                rowsPerPage={ROW_BY_PAGE_OPTIONS}
                                page={parseInt(this.props.page, 10)}
                                numberOfRows={parseInt(this.props.numberOfRowsPerPage || ROW_BY_PAGE_OPTIONS[0], 10)}
                                updateRows={(state) => {
                                    this.props.updatePagination(state.page, state.numberOfRows);
                                }}/>
                </div>
            </div>
        );
    }

    isSelected(item) {
        return this.props.selected && this.props.selected.indexOf(item) !== -1;
    };

    displayHeaders(headerList) {
        return (
            <TableHeader
                displaySelectAll={this.props.showCheckboxes || false}
                adjustForCheckbox={this.props.showCheckboxes || false}
                enableSelectAll={this.props.enableSelectAll || false}
            >
                <TableRow>
                    {headerList.map((header, index) => {
                        //La liste de header est une liste de clé, on map ces clés dans le fichier i18n pour récupérer leurs labels
                        return (
                            <TableHeaderColumn
                                key={index}
                            >
                                {T.translate('tableFields.' + header)}
                            </TableHeaderColumn>
                        )
                    })}
                </TableRow>
            </TableHeader>
        );
    }

    displayBody() {
        return (
            <TableBody
                displayRowCheckbox={this.props.showCheckboxes || false}
                deselectOnClickaway={this.props.deselectOnClickaway || false}
                showRowHover={this.props.showRowHover || false}
                stripedRows={this.props.stripedRows || false}
                className={this.props.selectable ? 'selectable' : null}
            >
                {this.props.totalColumns ?
                    <TableRow>
                        {this.props.totalColumns()}
                    </TableRow>
                    : ""
                }
                {this.props.data.map((row, index) => (
                    this.renderRow(row, index)
                ))}
            </TableBody>
        );
    }

    //Affichage d'une ligne
    renderRow(row, index) {
        //Si une méthode pour afficher les colonnes est passée en paramètre, on l'utilise, sinon on utilise celle par défaut
        return (
            <TableRow key={index} selected={this.isSelected(this.props.data[index])}
                      className={this.isSelected(this.props.data[index]) ? "selected" : ""}>
                {this.props.renderColumns ? this.props.renderColumns(index) :
                    //Par défaut: on map les valeurs du dataset avec les clés de la liste de header
                    //Les clés doivent donc être les mêmes dans le dataset, dans la liste de headers et dans les fichiers i18n
                    //Cela permet de changer l'ordre des colonnes en changeant simplement la liste de header passée en paramètre
                    this.props.headerList.map((header, colIndex) =>
                        <TableRowColumn
                            key={colIndex}
                        >
                            {this.props.data[index][header] || T.translate('tableFields.missingData')}
                        </TableRowColumn>
                    )}
            </TableRow>
        )
    }

    handleSelection(selectedRows) {
        this.props.handleSelection(selectedRows)
    }
}

export default DynamicTable;


// WEBPACK FOOTER //
// ./src/components/tableComponent/dynamicTable/DynamicTable.js